export class BaseCurrencyConversion {
  taxYear: number;
  conversionValue: number;
}
